/*
 * @Author: ben ben
 * @Date: 2026-01-22 14:27:55
 * @LastEditors: ben ben
 * @LastEditTime: 2026-01-22 15:31:25
 * @Description: 意见反馈浮窗组件
 */
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { useState } from 'react';
import feedbackIcon from '@/assets/feedbackd.svg';
import styled from 'styled-components';
import feedbackSdk from '@/utils/feedbackSdk';

const FloatWindowWrapper = styled.div`
  position: fixed;
  z-index: 2000;
  width: 50px;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background-color: rgba(222, 223, 227, 0.75);
  border-radius: 10px 0 0 10px;
  transition: all 0.35s ease;
  opacity: ${(props) => (props.$ishidden ? 0 : 1)};
  width: ${(props) => (props.$ishidden ? 0 : 50)}px;
  visibility: ${(props) => (props.$ishidden ? 'hidden' : 'visible')};
`;

const IconItemWrapper = styled.div`
  color: #333;

  .icon-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 60px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);

      img {
        filter: drop-shadow(0 0 2px rgba(51, 85, 255, 0.3));
      }
    }

    img {
      width: 24px;
      height: 24px;
      margin-bottom: 4px;
      transition: all 0.2s ease;
    }
  }
`;

const CloseButtonWrapper = styled.div`
  height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: rgba(102, 102, 102, 1);

  &:hover {
    color: rgba(51, 85, 255, 1);
  }
`;

const FloatWindowContainerWrapper = styled.div`
  position: fixed;
  z-index: 1999;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  top: 50%;
  right: -8px;
  transform: translateY(-50%);
  background-color: #3355ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-50%) scale(1.2);

    svg {
      color: #fff;
    }
  }
`;

const PopoverContent = styled.div`
  .tips-title {
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
  }

  .tips-alert {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }

  .tips-text {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
  }
`;

const FeedbackFloatingEntry = ({ username = '' }) => {
  const [isHidden, setIsHidden] = useState(false);

  const handleOpenFeedback = () => {
    console.log('yyyy~~~~');
    if (feedbackSdk.open) {
      feedbackSdk.open(username);
    }
  };

  const popoverContent = (
    <PopoverContent>
      <div className="tips-title">意见反馈</div>
      <div className="tips-alert">你对平台有什么建议吗？</div>
      <div className="tips-text">欢迎描述具体问题或改进意见，在此进行反馈！</div>
    </PopoverContent>
  );

  return (
    <>
      {!isHidden && (
        <FloatWindowWrapper $ishidden={isHidden}>
          <IconItemWrapper>
            <Popover
              content={popoverContent}
              placement="left"
              overlayStyle={{ maxWidth: '280px' }}
              trigger="hover"
            >
              <div className="icon-item" onClick={handleOpenFeedback}>
                <img src={feedbackIcon} alt="反馈" />
                <div>反馈</div>
              </div>
            </Popover>
          </IconItemWrapper>
          <CloseButtonWrapper onClick={() => setIsHidden(true)}>
            <ArrowRightOutlined style={{ fontSize: '10px' }} />
          </CloseButtonWrapper>
        </FloatWindowWrapper>
      )}

      {isHidden && (
        <FloatWindowContainerWrapper onClick={() => setIsHidden(false)}>
          <ArrowLeftOutlined style={{ fontSize: '15px', color: 'rgba(102, 102, 102, 1)' }} />
        </FloatWindowContainerWrapper>
      )}
    </>
  );
};

FeedbackFloatingEntry.defaultProps = {
  username: '',
};

export default FeedbackFloatingEntry;
